import React from 'react';
import styled from 'styled-components';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import SettingCard, { SettingInfoBox, SettingInfoLabel, SettingInfoValue, CardFooter, SaveButton } from './SettingCard';

const RadioFrame = styled.div`
    display: inline-flex;
    align-items: center;
    background: #f8f9fb;
    border: 1px solid #e0e4ea;
    border-radius: 20px;
    padding: 2px 14px;
    transition: border-color 0.15s ease;

    .MuiFormControlLabel-label {
        font-size: 0.95rem;
        color: #555;
    }
`;

const AdminClubAttendAppInfo = ({
    selectClubInfo,
    setAttendAppActive,
    setChangeAttendAppActiveInfo
}) => {

    const onChangeAttendAppActive = (e) => {
        setAttendAppActive(parseInt(e.target.value))
    }

  return selectClubInfo ? (
    <SettingCard title="출석앱 사용 유무">
        <SettingInfoBox>
            <SettingInfoLabel>사용 유무</SettingInfoLabel>
            <SettingInfoValue>
                <RadioFrame>
                    <RadioGroup
                        aria-label="attendAppActive"
                        name="attendAppActive"
                        value={selectClubInfo.attendAppActive != null ? selectClubInfo.attendAppActive : 0}
                        onChange={onChangeAttendAppActive}
                        row={true}
                    >
                        <FormControlLabel
                            value={1}
                            control={<Radio color="primary" />}
                            label="사용"
                        />
                        <FormControlLabel
                            value={0}
                            control={<Radio color="primary" />}
                            label="미사용"
                        />
                    </RadioGroup>
                </RadioFrame>
            </SettingInfoValue>
        </SettingInfoBox>
        <CardFooter>
            <SaveButton active={selectClubInfo.isAttendAppActiveEdit} onClick={() => setChangeAttendAppActiveInfo()}>
                수정하기
            </SaveButton>
        </CardFooter>
    </SettingCard>
  ) : null;
};

export default React.memo(AdminClubAttendAppInfo);
